export enum PermissionLevel {
  FREE = "FREE",
  BASIC = "BASIC",
  TEAMS_BASIC = "TEAMS_BASIC",
  SOCIETAL = "SOCIETAL",
  TEAMS_SOCIETAL = "TEAMS_SOCIETAL",
  TRIAL = "TRIAL",
}
